"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _reactDom = require("react-dom");
var _hooks = require("../../hooks");
var Portal = function Portal(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  var element = (0, _react.useRef)(document.createElement('div'));
  (0, _hooks.useWillMount)(function () {
    document.body.appendChild(element.current);
  });
  (0, _react.useEffect)(function () {
    return function () {
      document.body.removeChild(element.current);
      return;
    };
  }, []);
  return /*#__PURE__*/(0, _reactDom.createPortal)(children, element.current);
};
var _default = exports["default"] = Portal;